var map = {
	"./commerce/new-order/index.js": [
		297,
		1
	],
	"./serving-center/index.js": [
		298,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 251;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/frontend/page-helpers lazy ^\.\/.*\/index\.js$
// module id = 251
// module chunks = 6